var cookie = require('cookie');

function getCookie(name) {
  var cookies = cookie.parse(document.cookie);

  return cookies[name];
}

function setCookie(name, value, opts) {
  var maxAge = new Date();
  var cookieString;
  var options = {
    maxAge: 180, // 6 months
  };

  if (opts) { // rewrite options if opts exist
    Object.keys(opts).forEach(function tet(key) {
      options[key] = opts[key];
    });
  }

  maxAge.setDate(maxAge.getDate() + options.maxAge);
  options.expires = maxAge;
  options.maxAge = null;

  cookieString = cookie.serialize(name, value, options);

  document.cookie = cookieString;
}

module.exports = {
  cookie: {
    set: setCookie,
    get: getCookie,
  },
};
